import { gql } from '@apollo/client';
import type { Alignment } from '@snapchat/snap-design-system-marketing';

import { type CtaData, ctaFragment } from '../../../../components/CallToAction/query';
import { type ImageDataProps, fragments as imageFragments } from '../../../../components/Image';
import { type VideoDataProps, fragments as videoFragments } from '../../../../components/Video';
import type { ContentfulSysProps } from '../../../../types/contentful';
import type { RichText } from '../../../../types/RichText';
import { contentfulSysIdFragment } from '../../../../utils/contentful/contentfulQuery';

export interface ArDownloadLinkCardQuery {
  arDownloadLinkCard: ArDownloadLinkCardDataProps;
}

export interface ArDownloadLinkCardDataProps extends ContentfulSysProps {
  contentfulDescription: string;
  title?: RichText | string;
  body?: RichText | string;
  titleAlignment?: Alignment;
  bodyAlignment?: Alignment;
  flex?: number;
  backgroundImage?: ImageDataProps | VideoDataProps;
  backgroundColor?: string;
  ctaColor?: string;
  icon?: ImageDataProps;
  callToActionsCollection?: {
    items: CtaData[];
  };
}

export const arDownloadLinkCardFragment = {
  all: gql`
    fragment ArDownloadLinkCardAll on ArDownloadLinkCard {
      ...ContentfulSysId
      contentfulDescription
      title {
        json
      }
      body {
        json
      }
      titleAlignment
      bodyAlignment
      flex
      backgroundImage {
        ... on Image {
          ...ImageAll
        }
        ... on Video {
          ...VideoAll
        }
      }
      backgroundColor
      ctaColor
      icon {
        ...ImageAll
      }
      callToActionsCollection(limit: 3) {
        items {
          ...CallToActionAll
        }
      }
    }
    ${contentfulSysIdFragment}
    ${imageFragments.all}
    ${videoFragments.all}
    ${ctaFragment}
  `,
};

export const query = gql`
  query ArDownloadLinkCardQuery($id: String!, $preview: Boolean!, $locale: String!) {
    arDownloadLinkCard(id: $id, preview: $preview, locale: $locale) {
      ...ArDownloadLinkCardAll
    }
  }
  ${arDownloadLinkCardFragment.all}
`;
